module.exports = __webpack_public_path__ + "media/images/icons/ic-search-821f874264d2c3ae628ab05bb36d03c2.svg";